module.exports = __webpack_public_path__ + "static/media/panel_top_rocket.bac69d76.png";